export const witnessQuest = {
    id: 'accidental_witness',
    titleKey: 'chapter_witness',
    shortName: 'WITNS',
    date: '17.11.2025',
    status: 'locked',
    questMap: [
        {
            id: 'step_start',
            label: {
                en: "How to start quest",
                tr: "Göreve nasıl başlanır",
                ru: "Как начать квест"
            },
            type: 'start',
            isSubTask: false,
            details: {
                location: {
                    tr: "Gümrük",
                    en: "Customs",
                    ru: "Таможня"
                },
                requiredItems: [
                    { en: "Dorms 110 Key", tr: "Yurt 110 Anahtarı", ru: "Ключ от комнаты 110 общежития" }
                ],
                objective: {
                    en: "Check the Car & Room 110",
                    tr: "Arabayı ve 110 numaralı odayı kontrol et",
                    ru: "Проверьте автомобиль и комнату 110"
                },
                warning: {
                    en: "Bring the '2 Story Dorms 110 Key'! You will need it immediately after checking the car.",
                    tr: "'2 Katlı Yurt 110 Anahtarı'nı yanına al! Arabayı kontrol ettikten hemen sonra lazım olacak.",
                    ru: "Возьмите ключ от комнаты 110 двухэтажного общежития! Он понадобится сразу после осмотра машины."
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Customs. Head to the front of the 3-story Dorms.",
                            tr: "Gümrük haritasına gir. 3 katlı yurdun ön tarafına git.",
                            ru: "Перейдите на Таможню. Идите к передней части трёхэтажного общежития."
                        },
                        images: ['/Story/AccidentalWitness/Step1.webp', '/Story/AccidentalWitness/Step1-1.webp']
                    },
                    {
                        text: {
                            en: "Objective Update: Go to the 2-story Dorms building right next to you.",
                            tr: "Hedef Güncellendi: Hemen yanındaki 2 katlı Yurt binasına geç.",
                            ru: "Цель обновлена: Перейдите в соседнее двухэтажное общежитие."
                        }
                    },
                    {
                        text: {
                            en: "Go to the 1st floor. Pick up the note right by the door.",
                            tr: "1. kata git. Kapının yanındaki notu al.",
                            ru: "Идите на 1 этаж. Подберите записку у двери."
                        },
                        images: ['/Story/AccidentalWitness/Step1-2.webp', '/Story/AccidentalWitness/Step1-3.webp']
                    }
                ]
            }
        },
        {
            id: 'step_110',
            label: {
                en: "Get into room №110 in the two-story dormitory",
                tr: "İki katlı yurttaki 110 numaralı odaya gir",
                ru: "Войдите в комнату №110 в двухэтажном общежитии"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: {
                    tr: "Gümrük (2 Katlı Yurtlar)",
                    en: "Customs (2-Story Dorms)",
                    ru: "Таможня (2-этажное общежитие)"
                },
                objective: {
                    en: "Enter Room 110 in the 2-story dorms (Ground Floor). Unlock it with the key.",
                    tr: "2 katlı yurdun zemin katındaki 110 numaralı odaya git. Anahtarı kullanarak kapıyı aç.",
                    ru: "Зайдите в комнату 110 в двухэтажном общежитии (1 этаж). Откройте дверь ключом."
                },
                requiredItems: [
                    { en: "Dorms 110 Key", tr: "Yurt 110 Anahtarı", ru: "Ключ от комнаты 110 общежития" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Enter Room 110 in the 2-story dorms (Ground Floor). Unlock it with the key.",
                            tr: "2 katlı yurdun zemin katındaki 110 numaralı odaya git. Anahtarı kullanarak kapıyı aç.",
                            ru: "Зайдите в комнату 110 в двухэтажном общежитии (1 этаж). Откройте дверь ключом."
                        },
                    },
                    {
                        text: {
                            en: "Look for a note inside the room (check the bed/table). Pick it up.",
                            tr: "Odanın içindeki notu ara (yatağın üzerine veya masaya bak). Notu al.",
                            ru: "Найдите записку в комнате (проверьте кровать/стол). Возьмите её."
                        },
                        images: ['/Story/AccidentalWitness/Step2.webp']
                    },
                    {
                        text: {
                            en: "Go to the trader menu and hand over the info to Skier.",
                            tr: "Satıcılar menüsüne dön ve bilgiyi Skier'a (Kayakçı) teslim et.",
                            ru: "Идите в меню торговцев и передайте информацию Лыжнику (Skier)."
                        }
                    }
                ],
                story: {
                    en: "\"I managed to get into Room 110. It looks abandoned in a hurry. I found a note inside... reading it makes me think Skier knows something about these people. I need to get out and talk to him.\"",
                    tr: "\"110 numaralı odaya girmeyi başardım. Aceleyle terk edilmiş görünüyor. İçeride bir not buldum... okuduklarım bana Kayakçı'nın bu adamlar hakkında bir şeyler bildiğini düşündürüyor. Buradan çıkıp onunla konuşmalıyım.\"",
                    ru: "\"Мне удалось попасть в 110-ю комнату. Похоже, её покидали в спешке. Я нашёл записку... судя по тексту, Лыжник что-то знает об этих людях. Нужно выбираться и поговорить с ним.\""
                },
            }
        },
        {
            id: 'step_ask_skier',
            label: {
                en: "Ask the traders about Anastasia",
                tr: "Tüccarlara Anastasia hakkında soru sor",
                ru: "Спросите торговцев об Анастасии"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: {
                    tr: "Menü / Kayakçı",
                    en: "Menu / Skier",
                    ru: "Меню / Лыжник"
                },
                objective: {
                    en: "Talk to Skier.",
                    tr: "Kayakçı (Skier) ile konuş.",
                    ru: "Поговорите с Лыжником."
                },
                story: {
                    en: "\"Talk to Skier and find out the details about Kozlov, Anastasia, and his former accomplice. After that, Skier sends you to search for the apartment.\"",
                    tr: "\"Kayakçı ile konuş ve Kozlov, Anastasia ve eski ortağı hakkındaki detayları öğren. Bundan sonra Kayakçı seni daireyi aramaya gönderecek.\"",
                    ru: "\"Поговорите с Лыжником и узнайте подробности о Козлове, Анастасии и его бывшем сообщнике. После этого Лыжник отправит вас обыскивать квартиру.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to the MAIN MENU > TRADERS > SKIER. After talking to Skier, you will get a new objective.",
                            tr: "ANA MENÜ > SATICILAR > KAYAKÇI'ya git. Kayakçı ile konuştuktan sonra yeni hedefi alacaksın.",
                            ru: "ГЛАВНОЕ МЕНЮ > ТОРГОВЦЫ > ЛЫЖНИК (SKIER). Поговорите с Лыжником, чтобы получить новую цель."
                        },
                    }
                ]
            }
        },
        {
            id: 'step_apartment',
            label: {
                en: "Visit Skier’s accomplice’s apartment",
                tr: "Skier'ın suç ortağının dairesini ziyaret et",
                ru: "Посетите квартиру сообщника Лыжника"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: {
                    tr: "Tarkov'un sokakları",
                    en: "Streets of Tarkov",
                    ru: "Улицы Таркова"
                },
                objective: {
                    en: "Go to the accomplice's apartment.",
                    tr: "Suç ortağının dairesine git.",
                    ru: "Отправляйтесь в квартиру сообщника."
                },
                requiredItems: [
                    { en: "Accomplice's Apartment Key", tr: "Suç Ortağının Daire Anahtarı", ru: "Ключ от квартиры сообщника" }
                ],
                story: {
                    en: "\"Skier gave up the address. Zmeysky Avenue, building 3. His 'associate' might have left something behind about Anastasia or Kozlov.\"",
                    tr: "\"Kayakçı adresi verdi. Zmeysky Caddesi, Bina 3. 'Ortağı' Anastasia veya Kozlov hakkında arkada bir şeyler bırakmış olabilir.\"",
                    ru: "\"Лыжник дал адрес. Змейский проспект, дом 3. Его «партнёр» мог оставить что-то важное об Анастасии или Козлове.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Streets of Tarkov. Locate Building 3 on Zmeysky Avenue.",
                            tr: "Tarkov'un Sokaklarına git. Zmeysky Caddesi üzerindeki 3 numaralı binayı bul.",
                            ru: "Идите на Улицы Таркова. Найдите дом 3 на Змейском проспекте."
                        },
                        images: ['/Story/AccidentalWitness/Step4.webp', '/Story/AccidentalWitness/Step4-1.webp', '/Story/AccidentalWitness/Step4-req.webp']
                    },
                    {
                        text: {
                            en: "Enter the building. The apartment is on the 1st floor, left of the stairs. Open it with the key.",
                            tr: "Binaya gir. Daire zemin katta (1. kat), merdivenlerin solunda. Anahtarla kapıyı aç.",
                            ru: "Зайдите в подъезд. Квартира на 1 этаже, слева от лестницы. Откройте ключом."
                        },
                        images: []
                    },
                    {
                        text: {
                            en: "Collect the Letters and 3 Newspaper Clippings from the walls in different rooms.",
                            tr: "Odalardaki duvarlara asılmış Mektupları ve 3 Gazete Kupürünü topla (Toplam 4 parça).",
                            ru: "Соберите письма и 3 газетные вырезки со стен в разных комнатах."
                        },
                        images: [
                            '/Story/AccidentalWitness/Step4-smallstep2-1.webp',
                            '/Story/AccidentalWitness/Step4-smallstep2-2.webp',
                            '/Story/AccidentalWitness/Step4-smallstep2-3.webp',
                            '/Story/AccidentalWitness/Step4-smallstep2-4.webp'
                        ]
                    },
                    {
                        text: {
                            en: "Survive and EXTRACT from the location.",
                            tr: "Hayatta kal ve haritadan ÇIKIŞ YAP (Extract).",
                            ru: "Выживите и ЭВАКУИРУЙТЕСЬ с локации."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_anastasia_apt',
            label: {
                en: "Find Anastasia's Apartment",
                tr: "Anastasia'nın dairesini bul",
                ru: "Найдите квартиру Анастасии"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: {
                    tr: "Tarkov'un sokakları",
                    en: "Streets of Tarkov",
                    ru: "Улицы Таркова"
                },
                objective: {
                    en: "Find Anastasia's Apartment",
                    tr: "Anastasia'nın dairesini bul",
                    ru: "Найдите квартиру Анастасии"
                },
                story: {
                    en: "\"Skier pointed to Chekannaya Street 13, Apartment 7. He thinks Anastasia might be hiding there. I need to check if she's still around or if the trail has gone cold.\"",
                    tr: "\"Kayakçı, Chekannaya Caddesi 13 numara, Daire 7'yi işaret etti. Anastasia'nın orada saklanıyor olabileceğini düşünüyor. Hâlâ orada mı yoksa iz çoktan soğudu mu, kontrol etmem gerek.\"",
                    ru: "\"Лыжник указал на Чеканную улицу, дом 13, квартира 7. Он думает, что Анастасия может прятаться там. Нужно проверить, там ли она ещё, или след простыл.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Streets of Tarkov. Locate the residential building at Chekannaya Street 13.",
                            tr: "Tarkov'un Sokaklarına git. Chekannaya Caddesi 13 numaradaki konut binasını bul.",
                            ru: "Идите на Улицы Таркова. Найдите жилой дом на ул. Чеканная, 13."
                        },
                        images: ['/Story/AccidentalWitness/Step5.webp', '/Story/AccidentalWitness/Step5-4.webp']
                    },
                    {
                        text: {
                            en: "Enter through the front door. See screenshot below.",
                            tr: "Ön kapıdan içeriye gir. Aşağıdaki ekran görüntüsünü incele.",
                            ru: "Зайдите через парадную дверь. Скриншот ниже."
                        },
                        images: ['/Story/AccidentalWitness/Step5-1.webp']
                    },
                    {
                        text: {
                            en: "Enter the building and look to your right — there will be a mailbox. On top of it there will be a letter and a newspaper. Pick them up.",
                            tr: "Binaya gir ve sağ tarafa bak — bir posta kutusu olacak. Üstünde bir mektup ve gazete bulacaksın. Onları al.",
                            ru: "Зайдите в подъезд. Справа будет почтовый ящик. На нём будут письмо и газета. Соберите их."
                        },
                        images: ['/Story/AccidentalWitness/Step5-2.webp']
                    },
                    {
                        text: {
                            en: "After you pick up the items, the sub-task will complete. Go straight up the stairs; when you turn left you will see door number 7. Interact -> BREACH the door.",
                            tr: "Eşyaları aldıktan sonra alt görev tamamlanacak. Merdivenden yukarı çık; sol tarafta 7 numaralı kapı olacak. Kapı ile etkileşime geç ve KIRARAK (Breach) gir.",
                            ru: "После того как подберёте предметы, подзадание засчитается. Поднимитесь по лестнице; слева будет дверь №7. Взаимодействуйте с дверью — ВЗЛОМАЙТЕ её."
                        },
                        images: ['/Story/AccidentalWitness/Step5-3.webp']
                    }
                ]
            }
        },
        {
            id: 'step_courier_reshala',
            label: {
                en: "Search for the courier and Reshala’s temporary hideout",
                tr: "Kuryeyi ve Reshala'nın geçici sığınağını ara",
                ru: "Найдите курьера и временное убежище Решалы"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: {
                    tr: "Gümrük",
                    en: "Customs",
                    ru: "Таможня"
                },
                objective: {
                    en: "Search for the courier and Reshala's temporary hideout",
                    tr: "Kurye Pasha'yı ve Reshala'nın geçici sığınağını bul",
                    ru: "Найдите курьера и временное укрытие Решалы"
                },
                requiredItems: [
                    { en: "Key to Reshala's temporary house", tr: "Reshala'nın geçici evinin anahtarı", ru: "Ключ от времянки Решалы" }
                ],
                warning: {
                    en: "You need the key to open the hideout. It can be found on Reshala's body (chance) or Flea Market.",
                    tr: "Sığınağı açmak için anahtar şart. Reshala'nın üzerinden (şans) veya Bit Pazarı'ndan bulabilirsin.",
                    ru: "Для открытия убежища нужен ключ. Можно найти у Решалы (шанс) или на Барахолке."
                },
                story: {
                    en: "\"The trail leads to Customs. Pasha the courier didn't make it. His documents mention Reshala and 'The Solution'. Skier says Reshala has a temporary hideout near the library. I need to find that key and see what they were planning.\"",
                    tr: "\"İpuçları Gümrük'e çıkıyor. Kurye Pasha başaramamış. Belgeleri Reshala ve 'Çözüm'den bahsediyor. Kayakçı, Reshala'nın kütüphane (Crackhouse) yakınında geçici bir sığınağı olduğunu söylüyor. O anahtarı bulup ne planladıklarını görmem gerek.\"",
                    ru: "\"Следы ведут на Таможню. Курьер Паша не выжил. В его документах упоминается Решала и «Решение». Лыжник говорит, у Решалы есть времянка у библиотеки. Нужно найти ключ и узнать их планы.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Customs, behind the 2-Story Dorms. Look for a stone with a broken bike nearby.",
                            tr: "Gümrük haritasına git, 2 Katlı Yurdun arkasındaki ormanlık alana bak. Kırık bir bisikletin olduğu taşı bul.",
                            ru: "Идите на Таможню, за двухэтажное общежитие. Найдите камень с разбитым велосипедом."
                        },
                        images: ['/Story/AccidentalWitness/Step6-1.webp', '/Story/AccidentalWitness/Step6-7.webp']
                    },
                    {
                        text: {
                            en: "Search next to the bike. Take the documents. Read the documents.",
                            tr: "Bisikletin etrafını ara. Belgeleri al. Belgeleri oku.",
                            ru: "Обыщите рядом с велосипедом. Заберите документы. Прочитайте их."
                        },
                        images: ['/Story/AccidentalWitness/Step6-2.webp']
                    },
                    {
                        text: {
                            en: "Go to the 'Crackhouse' (Library) area. Find the trailer/cabin near the bus stop.",
                            tr: "'Crackhouse' (Kütüphane) bölgesine git. Otobüs durağının yanındaki konteyner/kulübeyi bul.",
                            ru: "Идите к «Крекхаусу» (Библиотеке). Найдите вагончик у автобусной остановки."
                        },
                        images: ['/Story/AccidentalWitness/Step6-3.webp', '/Story/AccidentalWitness/Step6-4.webp', '/Story/AccidentalWitness/Step6-8.webp']
                    },
                    {
                        text: {
                            en: "Take the 1 LETTER on the chair and the 2 NOTES on the walls. Read them.",
                            tr: "Sandalyedeki 1 adet MEKTUBU ve duvarlardaki 2 adet NOTU al. Okumayı unutma.",
                            ru: "Заберите 1 ПИСЬМО на стуле и 2 ЗАПИСКИ на стенах. Прочитайте их."
                        },
                        images: ['/Story/AccidentalWitness/Step6-5.webp', '/Story/AccidentalWitness/Step6-6.webp']
                    }
                ]
            }
        },
        {
            id: 'step_final_cassette',
            label: {
                en: "Find the Cassette on Shoreline",
                tr: "Shoreline'daki kaseti bul",
                ru: "Найдите кассету на Берегу"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: {
                    tr: "Kıyı Şeridi (Köy)",
                    en: "Shoreline (Village)",
                    ru: "Берег (Деревня)"
                },
                objective: {
                    en: "Find the Cassette on Shoreline",
                    tr: "Kıyı Şeridi'ndeki kaseti bul",
                    ru: "Найдите кассету на Берегу"
                },
                warning: {
                    en: "Recommendation: Bring a 'Tape Recorder' with you to listen to the cassette immediately.",
                    tr: "Tavsiye: Kaseti hemen dinleyebilmek için yanına bir 'Kasetçalar' (Tape Recorder) almanı öneririz.",
                    ru: "Рекомендация: Возьмите с собой «Диктофон» (Tape Recorder), чтобы сразу прослушать кассету."
                },
                story: {
                    en: "\"The courier's documents pointed to a safe house on the coast. Shoreline, the village near the tunnel. 3 Tsvetochnaya Street. The final piece of the puzzle regarding 'The Solution' should be there.\"",
                    tr: "\"Kuryenin belgeleri sahil tarafında güvenli bir evi işaret ediyordu. Kıyı Şeridi, tünelin yanındaki köy. Tsvetochnaya Caddesi 3 numara. 'Çözüm' ile ilgili yapbozun son parçası orada olmalı.\"",
                    ru: "\"Документы курьера указывали на конспиративную квартиру на побережье. Берег, деревня у туннеля. Улица Цветочная, 3. Последняя часть головоломки о «Решении» должна быть там.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Shoreline. Head to the Village area (near the Tunnel extract).",
                            tr: "Kıyı Şeridi haritasına git. Tünel çıkışının (Tunnel Extract) yanındaki Köy bölgesine ilerle.",
                            ru: "Идите на Берег. Направляйтесь в Деревню (возле выхода «Тоннель»)."
                        },
                        images: ['/Story/AccidentalWitness/Step7-1.webp']
                    },
                    {
                        text: {
                            en: "Locate the house at '3 Tsvetochnaya St'. It's a wooden house with a fence.",
                            tr: "'Tsvetochnaya Cad. 3 Numara'daki evi bul. Çitleri olan ahşap bir ev.",
                            ru: "Найдите дом по адресу «ул. Цветочная, 3». Это деревянный дом с забором."
                        },
                        images: ['/Story/AccidentalWitness/Step7-2.webp']
                    },
                    {
                        text: {
                            en: "Look into the flower pot with a shovel right next to the entrance/porch.",
                            tr: "Girişin/verandanın hemen yanındaki içerisinde kürek olan çiçekliğe bak.",
                            ru: "Загляните в клумбу с лопатой прямо у входа/крыльца."
                        },
                        images: ['/Story/AccidentalWitness/Step7-3.webp']
                    },
                    {
                        text: {
                            en: "Pick up and 'Listen' to the cassette. Quest chain COMPLETE.",
                            tr: "Kaseti al ve 'Dinle'. Görev zinciri TAMAMLANDI.",
                            ru: "Подберите и «Прослушайте» кассету. Цепочка квестов ЗАВЕРШЕНА."
                        }
                    }
                ]
            }
        }
    ]
};